import { SystemStatusPage } from "@nens/ranalib";

import { BasePage } from "@/components/base-page";
import { ProjectTabs } from "@/features/project";
import { useProjectQuery } from "@/queries/query-project";

interface ProjectPageProps {
  slug: string;
}

export function ProjectPage({ slug }: ProjectPageProps) {
  const { data: project, isLoading } = useProjectQuery({ slug });

  if (!project && !isLoading) {
    return <SystemStatusPage variant="not-found" />;
  }

  return (
    // Title will be set in project-tabs.tsx
    <BasePage activeSidebarButton="projects" pageSubTitle={undefined}>
      <ProjectTabs slug={slug} />
    </BasePage>
  );
}
